define('v3/Common/Components/Rainbowchart/RainbowChart.Component',[
	'jquery',
	'text!v3/Common/Components/RainbowChart/RainbowChart.Component.html',
	'v3/Common/Models/enums',
	'moment',
	'lodash',
	'knockout',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/Pages/AbilityGraph/Services/Backend/backendReport',
	'v3/Pages/AbilityGraph/ViewModels/UpdateTargetAbilityViewModel',
	'v3/Common/Bindings/Tooltip.Binding',
	'v3/Common/Bindings/InsertSvgChart.Binding',
	'v3/Common/Bindings/Numeric.Binding',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/FromV2/utils'
], function ($, template, enums, moment, _, ko, frontend, backendReport, UpdateTargetAbilityViewModel) {
	var width = 994;
	var height = 423;
	var daysInYear = 365.25;

	function rainbowChart (params) {
		var self = this;

		var subjectGroupId = ko.isObservable(params.subjectGroupId) ? params.subjectGroupId : ko.observable(params.subjectGroupId);
		var objectType = ko.isObservable(params.objectType) ? params.objectType : ko.observable(params.objectType);
		var objectId = ko.isObservable(params.objectId) ? params.objectId : ko.observable(params.objectId);
		var pupil = ko.isObservable(params.pupil) ? params.pupil : ko.observable(params.pupil);
		var isDLEVisible = !params.hideDLE && Settings.isDidacticAgeEquivalentAvailable;

		self.isLoading = ko.observable(true);
		self.pupilDAE = params.pupilDAE || ko.observable({});
		self.fullSize = params.fullSize || false;
		self.useImage = ko.observable(ko.unwrap(params.useImage) || false);
		self.imageLoaded = params.imageLoaded || _.noop;
		self.usePng = params.usePng || false;
		self.pupilData = params.pupilData;

		self.isRainbowChartLoading = ko.computed(function () {
			return self.imageLoaded() === false;
		});

		self.isRainbowChartLoaded = ko.computed(function () {
			return self.imageLoaded() === true;
		});

		if (params.isDLEVisible) {
			params.isDLEVisible(isDLEVisible);
		}

		var graphData = ko.observable();
		self.targetAbility = ko.observable();

		self.isSetAutomatically = ko.computed(function () {
			var targetAbilityValue = self.targetAbility() || {};

			return !!targetAbilityValue.isSetAutomatically;
		});

		self.hasAbilityData = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData) return false;

			return !_.isEmpty(currentGraphData.points);
		});

		self.hasBoundaryData = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData) return false;

			return currentGraphData.abilityBoundaries &&
				(currentGraphData.abilityBoundaries.min > 0 && currentGraphData.abilityBoundaries.max > 0);
		});

		self.showChart = ko.computed(function () {
			return self.isRainbowChartLoaded() &&
				self.hasBoundaryData();
		});

		self.showChartAndAbility = ko.computed(function () {
			return self.isRainbowChartLoaded() &&
				self.hasAbilityData();
		});

		self.showMessage = ko.computed(function () {
			return !self.showChartAndAbility() && !self.isRainbowChartLoading();
		});

		self.rainbowChartNotAvailableTitle = Strings.RainbowChartNotAvailableForGradeAndSubject;

		function xScalePercentile (day, numberOfGrades) {
			return day * 100 / (numberOfGrades * daysInYear);
		}

		function yScalePercentile (ability, graphBoundaries) {
			return (graphBoundaries.max - ability) * 100.0 / (graphBoundaries.max - graphBoundaries.min);
		}

		function getDidacticAgeEquivalentText (didacticAgeEquivalent) {
			switch (didacticAgeEquivalent.mode) {
			case enums.didacticAgeEquivalentMode.NotFound:
				return Strings.Unknown;
			case enums.didacticAgeEquivalentMode.AboveMargins:
				return '> 60';
			case enums.didacticAgeEquivalentMode.BelowMargins:
				return '< 10';
			default:
				return didacticAgeEquivalent.score;
			}
		}

		function getToolTipHTML (point, title) {
			var secondLine = '<strong>{0}%</strong>'.formatEncodeArguments(point.percentile);

			if (isDLEVisible) { secondLine += ' {0} {1}'.formatRaw(Strings.DLE, _.escape(getDidacticAgeEquivalentText(point.didacticAgeEquivalent))); }

			return "<div class='graph-tooltip'>{0}<br/>{1}</div>".formatRaw(_.escape(title), parseInt(point.percentile) >= 0 ? secondLine : Strings.Unknown);
		}

		self.gradesCountClass = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData) return null;

			return 'grades-' + currentGraphData.gradeNames.length;
		});

		self.currentGradeNumClass = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData) return null;

			return 'currentGrade-' + currentGraphData.gradeIndex;
		});

		self.stateClass = ko.computed(function () {
			if (ko.unwrap(params.isMinimized)) {
				return 'minimized';
			}

			return '';
		});

		self.yearLabels = ko.computed(function () {
			var currentGraphData = graphData();
			if (!currentGraphData) return null;

			var hideLabels = ko.unwrap(params.isMinimized);

			var yearLabels = [];
			for (var i = 0; i < currentGraphData.gradeNames.length; i++) {
				var year = currentGraphData.startYear + i;
				yearLabels.push({
					gradeText: hideLabels ? '' : currentGraphData.gradeNames[i],
					yearText: hideLabels ? '' : year + ' - ' + (year + 1)
				});
			}

			return yearLabels;
		});

		self.monthLabels = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData) return null;

			function formatMonthLabel (date) {
				return moment(date).format("MMM 'YY");
			}

			var gradesCount = currentGraphData.gradeNames.length;

			var monthLabels = [];
			for (var i = 0; i < gradesCount; i++) {
				monthLabels.push(formatMonthLabel(new Date(currentGraphData.startYear + i, 7, 1)));
				monthLabels.push(formatMonthLabel(new Date(currentGraphData.startYear + i + 1, 0, 1)));
			}
			monthLabels.push(formatMonthLabel(new Date(currentGraphData.startYear + gradesCount, 7, 1)));

			return monthLabels;
		});

		self.chartData = ko.computed(function () {
			var currentGraphData = graphData();
			var targetAbilityValue = self.targetAbility() || {};
			var isLoading = self.isLoading();

			if (isLoading || !currentGraphData || _.isEmpty(currentGraphData.points)) { return null; }

			var gradesCount = currentGraphData.gradeNames.length;
			var graphBoundaries = currentGraphData.graphBoundaries;

			function xScale (day) {
				return day * width / (gradesCount * daysInYear);
			}

			function yScale (ability) {
				return (graphBoundaries.max - ability) * height / (graphBoundaries.max - graphBoundaries.min);
			}

			var svgPoints = _.map(currentGraphData.points, function (point) {
				return {
					x: xScale(point.day),
					y: yScale(point.ability)
				};
			});

			var chartData = {
				points: svgPoints,
				targetAbility: null
			};

			if (!targetAbilityValue.noData) {
				chartData.targetAbility = {
					x: xScale(targetAbilityValue.day),
					y: yScale(targetAbilityValue.ability)
				};
			}

			return chartData;
		});

		self.isTargetAbilityEditable = ko.computed(function () {
			var currentGraphData = graphData();
			var targetAbilityValue = self.targetAbility() || {};
			var isLoading = self.isLoading();

			return !(isLoading || !currentGraphData || targetAbilityValue.noData);
		});

		self.monthAbilityMarkers = ko.computed(function () {
			if (ko.unwrap(params.isMinimized)) return null;

			var currentGraphData = graphData();
			if (!currentGraphData || _.isEmpty(currentGraphData.monthPoints)) return null;

			var gradesCount = currentGraphData.gradeNames.length;
			var graphBoundaries = currentGraphData.graphBoundaries;

			return _(currentGraphData.monthPoints)
				.take(currentGraphData.monthPoints.length - 1)
				.map(function (monthPoint) {
					return {
						xPerc: xScalePercentile(monthPoint.day, gradesCount),
						yPerc: yScalePercentile(monthPoint.ability, graphBoundaries),
						tooltip: getToolTipHTML(monthPoint, Strings.Ability)
					};
				})
				.value();
		});

		self.currentAbilityMarker = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData || _.isEmpty(currentGraphData.monthPoints)) return null;

			var gradesCount = currentGraphData.gradeNames.length;
			var graphBoundaries = currentGraphData.graphBoundaries;

			var lastPoint = _.last(currentGraphData.monthPoints);

			self.pupilDAE(getDidacticAgeEquivalentText(lastPoint.didacticAgeEquivalent));

			return {
				xPerc: xScalePercentile(lastPoint.day, gradesCount),
				yPerc: yScalePercentile(lastPoint.ability, graphBoundaries),
				tooltip: getToolTipHTML(lastPoint, Strings.CurrentAbility)
			};
		});

		self.currentAbilityMarkerVisible = ko.observable(true).extend({ throttle: 200 });

		self.targetAbilityMarker = ko.computed(function () {
			var currentGraphData = graphData();
			var targetAbilityValue = self.targetAbility() || {};

			if (!currentGraphData || !self.chartData() || !self.isTargetAbilityEditable()) { return null; }

			return {
				xPerc: xScalePercentile(targetAbilityValue.day, currentGraphData.gradeNames.length),
				yPerc: yScalePercentile(targetAbilityValue.ability, currentGraphData.graphBoundaries)
			};
		});

		self.background = ko.computed(function () {
			var currentGraphData = graphData();

			if (!currentGraphData || !currentGraphData.abilityBoundaries) return null;

			var overallAbilityDiff = currentGraphData.graphBoundaries.max - currentGraphData.graphBoundaries.min;
			var rainbowAbilityDiff = currentGraphData.abilityBoundaries.max - currentGraphData.abilityBoundaries.min;

			var yPerc = 0;

			if (currentGraphData.abilityBoundaries.max < currentGraphData.graphBoundaries.max) {
				var indentTop = currentGraphData.graphBoundaries.max - currentGraphData.abilityBoundaries.max;
				var verticalFreeSpace = overallAbilityDiff - rainbowAbilityDiff;
				yPerc = indentTop * 100 / verticalFreeSpace;
			}

			return {
				url: backendReport.rainbowChartBaseUrl + currentGraphData.boundaryGraphUrl,
				height: rainbowAbilityDiff * 100 / overallAbilityDiff,
				y: yPerc
			};
		});

		ko.computed(function () {
			var subjectGroupIdValue = subjectGroupId();
			var objectTypeValue = objectType();
			var objectIdValue = objectId();
			var pupilId = pupil() ? pupil().userId : null;

			self.isLoading(true);

			graphData(null);
			self.targetAbility(null);

			if (!objectTypeValue || !objectIdValue || !pupilId || !subjectGroupIdValue) {
				self.isLoading(false);
				return;
			}

			loadChartData(subjectGroupIdValue, objectTypeValue, objectIdValue, pupilId)
				.then(function (graphDataRaw) {
					if (!graphDataRaw) return;
					graphData(new GraphData(graphDataRaw));
					self.targetAbility(graphDataRaw.targetAbility || { noData: true });
				})
				.fail(function () {
					self.targetAbility({ noData: true });
				})
				.always(function () {
					self.isLoading(false);
					self.imageLoaded(false);
				});
		});

		function loadChartData (subjectGroupId, objectType, objectId, pupilId) {
			switch (objectType) {
			case enums.chartLevel.subject:
				return backendReport.getUserSubjectGroupAbilityHistory(pupilId, objectId);
			case enums.chartLevel.subdomain:
				return backendReport.getUserSdAbilityHistory(pupilId, subjectGroupId, objectId);
			case enums.chartLevel.learningobjective:
				return backendReport.getUserLoAbilityHistory(pupilId, subjectGroupId, objectId);
			case enums.chartLevel.allpupils:
				return $.when(self.pupilData);
			}

			throw new Error('Unsupported objectType.');
		}

		self.openEditTargetAbilityDialog = function () {
			if (ko.unwrap(params.isMinimized)) {
				return;
			}

			if (objectType() !== enums.chartLevel.subject) { return; } // We don't support target ability for any other chart level

			var targetPercentile = self.targetAbility().percentile;
			var lastPoint = _.last(graphData().monthPoints);
			var currentPercentile = lastPoint ? lastPoint.percentile : 0;

			var viewModel = new UpdateTargetAbilityViewModel(
				objectId(),
				pupil(),
				targetPercentile,
				currentPercentile);

			frontend.modal.show({
				viewModel: viewModel,
				template: 'updateTargetAbilityDialog',
				settings: { title: Strings.EditTargetAbility, width: 550, dialogClass: 'dialog-with-title updateTargetAbilityDialog', loader: viewModel.isLoading }
			}).done(function (newTargetPercentile, newTargetAbility, isSetAutomatically) {
				self.updateTargetAbility(newTargetPercentile, newTargetAbility, isSetAutomatically);
			});
		};

		self.updateTargetAbility = function (percentile, ability, isSetAutomatically, lastAutomaticUpdate) {
			self.targetAbility().percentile = percentile;
			self.targetAbility().ability = ability;
			self.targetAbility().isSetAutomatically = isSetAutomatically;
			self.targetAbility().lastAutomaticUpdate = lastAutomaticUpdate;
			self.targetAbility.valueHasMutated();
		};

		self.classForTooltipPosition = ko.computed(function () {
			var targetAbilityMarker = self.targetAbilityMarker();
			var currentAbilityMarker = self.currentAbilityMarker();

			if (!targetAbilityMarker || !currentAbilityMarker) {
				return 'top';
			}

			return targetAbilityMarker.yPerc >= currentAbilityMarker.yPerc ? 'top' : 'bottom';
		});

		if (params.initCallback) {
			params.initCallback({
				openEditTargetAbilityDialog: self.openEditTargetAbilityDialog,
				hasAbilityData: self.hasAbilityData,
				targetAbility: self.targetAbility,
				updateTargetAbility: self.updateTargetAbility
			});
		}

		return self;
	}

	function GraphData (chartDataRaw) {
		var self = this;

		self.gradeNames = chartDataRaw.gradeNames;
		self.objectId = chartDataRaw.objectId;
		self.boundaryGraphUrl = chartDataRaw.boundaryGraphUrl;
		self.gradeIndex = chartDataRaw.gradeIndex;
		self.startYear = chartDataRaw.startYear;
		self.points = null;
		self.monthPoints = null;

		if (!_.isEmpty(chartDataRaw.points)) {
			self.points = chartDataRaw.points;
			self.monthPoints = chartDataRaw.monthPoints;
		}

		self.abilityBoundaries = null;
		self.graphBoundaries = null;

		if (!_.isEmpty(self.points)) {
			self.graphBoundaries = {
				min: _.minBy(self.points, function (p) { return p.ability; }).ability,
				max: _.maxBy(self.points, function (p) { return p.ability; }).ability
			};
		}

		if (_.isFinite(chartDataRaw.minPercAbility) && _.isFinite(chartDataRaw.maxPercAbility)) {
			self.abilityBoundaries = {
				min: chartDataRaw.minPercAbility,
				max: chartDataRaw.maxPercAbility
			};

			if (self.graphBoundaries) {
				self.graphBoundaries.min = Math.min(self.graphBoundaries.min, self.abilityBoundaries.min);
				self.graphBoundaries.max = Math.max(self.graphBoundaries.max, self.abilityBoundaries.max);
			} else {
				self.graphBoundaries = {
					min: self.abilityBoundaries.min,
					max: self.abilityBoundaries.max
				};
			}
		}
	}

	return { viewModel: rainbowChart, template: template };
});

